import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CacheRefreshService {
  private refreshUntil = 0;
  private readonly defaultWindowMs = 5000;

  requestRefresh(windowMs: number = this.defaultWindowMs): void {
    this.refreshUntil = Date.now() + windowMs;
  }

  shouldBypass(): boolean {
    return Date.now() < this.refreshUntil;
  }
}
